import { UnReadMessage, UnReadMessagesByGuest } from "../types";
import { Message } from "@/modules/staff/objects/conversation/Message";

export default {
  voiceToTextAction: {}, // show/hide voice input window
  // subscribedUnreadMessage: {} as SubscriptionData, // 作成したサブスクリプションのオブジェクトを覚えておいて、ユーザーや会話が切り替わるなど、Subscribeする必要が無くなったタイミングで消すためのもの
  // subscribedUser: {} as SubscriptionData, // ?
  unreadMessageData: [] as UnReadMessage[], // unread  message data(show unread message count etc..)
  subscriptionsOnPage: <any>[],
  eventDataList: <any>[],
  hasStartedAppSyncSubscription: false,
  unsubscribeAll: false,
  currentMessages: [] as Message[],
  currentMessagesWithStaff: [] as Message[],
  currentConversationId: "",
  currentConversationIdWithStaff: "",
  currentConversationHideContact: false,
  conversationSurveyScores: [] as any[], //used to verify if convo has score submited; if so- don't show survey in convo
  startAppSyncSubscription: false,
  conversationIds: [],
  voiceChatStartingAction: {},
  voiceChatRespondAction: {},
  showNewIcon: false,
  unAssignedInquiryList: [],
  importance: "",
  forwardInquiryId: "", //dual purpose as a bool check for forwarding, and a container for inquiry id if being forwarded
  fromInquiryHistory: false, // TODO per below, can't remember what the issue was with this, so should be checked
  isContactButtonView: false, // in-app value exclusively for showing that the user came from a proper menu and not the history (where typer shouldn't show)
  noStaffCanRespondVoiceChatNotification: false,
  ticketQueueStopInquiry: false,
  showGuestLoading: false,
  runningEllipse: [],
  guestRunningEllipse: {},
  pwaGuestRunningEllipse: {},
  firstMessageFromGuest: "",
  unreadMessages: {} as UnReadMessagesByGuest, // staff,
  disableIncognitoModeNotification: false, // inroom-guest for showing incognitoPopupWarning
  alreadyNotifiedIncognitoMode: false, // inroom-guest for showing incognitoPopupWarning
  notifyIncognitoMode: false, // inroom-guest for showing incognitoPopupWarning
};
